module.exports = __webpack_public_path__ + "img/preview-9.2b454807.png";